export default {
    tag: 'video',
    labelTitle: '',
    labelColor: '',
    id: { value: null },
    content: '<iframe width="100%" height="350" src="https://www.youtube.com/embed/lRTtMcx6rSM" frameborder="0" allowfullscreen></iframe>',
    attributes: {
        basic: {
            margin: { title: 'Margin', comp: 'marginPadding', value: { top: 0, left: 0, right: 0, bottom: 0 } },
            // linkUrl: { title: 'VideoLink', comp: 'TextInput', value: '' },
            backgroundColor: { title: 'Background color', comp: 'colorPicker', value: 'transparent' },
            padding: { title: 'Padding', comp: 'marginPadding', value: { top: 0, left: 0, right: 0, bottom: 0 } },
            border: {
                title: 'Border',
                comp: 'border',
                value: {
                    width: 0,
                    color: 'transparent',
                    style: 'solid',
                    sides: { top: true, left: true, right: true, bottom: true },
                    radius: { leftTop: 0, topRight: 0, bottomRight: 0, bottomLeft: 0 },
                }
            },
        },
        advanced: {
            cssId: { title: 'ID', comp: 'TextInput', value: '' },
            cssClasses: { title: 'CSS Classes', comp: 'TextInput', value: [] },
            // alignment: { title: 'Alignment', comp: 'Alignment', value: { alignSide: 'left' } },
            alternateText: { title: 'Alternate text', comp: 'TextInput', value: '' },
        },
    },
}